export default __webpack_public_path__ + "static/media/weprofile-144x144.029656f7.png";